// const api_root = 'https://futures-without-violence-vpv.herokuapp.com'
const api_root = 'https://futures-without-violence-node.herokuapp.com'
const api_root_local = 'https://futures-without-violence-node.herokuapp.com'
// const api_root_local = 'http://localhost:4000'

let liveUrls = {
  server: {
    register: api_root + '/auth/register',
    login: api_root + '/auth/login',
    logout: api_root + '/auth/logout',
    authenticate: api_root + '/auth/authenticate',
    update: api_root + '/auth/update',
    preSurvey: api_root + '/survey/presurvey',
    postSurvey: api_root + '/survey/postsurvey'
  }
};

let devUrls = {
  server: {
    register: api_root_local + '/auth/register',
    login: api_root_local + '/auth/login',
    logout: api_root_local + '/auth/logout',
    authenticate: api_root_local + '/auth/authenticate',
    update: api_root_local + '/auth/update',
    preSurvey: api_root_local + '/survey/presurvey',
    postSurvey: api_root_local + '/survey/postsurvey'
  }
}

let apiUrls = {}

if (process.env.NODE_ENV === 'development') {
  console.log('api urls set to DEV')
  apiUrls = devUrls
} else {
  console.log('api urls set to PRODUCTION')
  apiUrls = liveUrls
}

export {apiUrls};


// WEBPACK FOOTER //
// ./src/utils/api_addresses.js